import CssBaseline from "@mui/material/CssBaseline";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { setupStore } from "../../_globalStore/redux/store";
import ThemeProvider from "../../_globalStore/themeProvider/ThemeProvider";
import { intlFormatDateShort } from "../time-utils";

export const exportContentToPDF = async (
  contentToExport: React.JSX.Element,
  setLoading: (loading: boolean) => void,
  fileName?: string,
  vertical?: boolean
) => {
  setLoading(true);
  const pageHeigth = vertical ? 1400 : 1000;
  const container = document.createElement("div");
  container.style.position = "absolute";
  container.style.transform = "translate(-9999px, -9999px)";
  container.style.width = vertical ? "1000px" : "1400px";

  const contentWrappedByTheme = (
    <Provider store={setupStore()}>
      <ThemeProvider>
        <CssBaseline>{contentToExport}</CssBaseline>
      </ThemeProvider>
    </Provider>
  );

  try {
    // Render the JSX.Element into the container
    ReactDOM.render(contentWrappedByTheme, container);
    if (container) {
      document.body.appendChild(container);

      const pages: string[] = [];
      const pdfPageWidth = vertical ? 210 : 297; // A4 width in mm
      const pdfPageHeight = vertical ? 297 : 210; // A4 height in mm
      let currentPage = 0;
      let yPos = 0;
      const capturePage = async () => {
        const canvas = await html2canvas(container as HTMLElement, {
          scale: 2,
          y: currentPage * pageHeigth,
          height: pageHeigth,
        });
        return canvas.toDataURL("image/png");
      };

      while (yPos < container.offsetHeight) {
        const imageData = await capturePage();
        pages.push(imageData);
        currentPage++;
        yPos = currentPage * pageHeigth;
      }
      const doc = new jsPDF(vertical ? "p" : "l", "mm", "a4");
      pages.forEach((imageData, index) => {
        if (index > 0) {
          doc.addPage();
        }
        const imgWidth = pdfPageWidth;
        const imgHeight = pdfPageHeight;
        doc.addImage(imageData, "PNG", 0, 0, imgWidth, imgHeight);
      });
      doc.save(`${fileName ?? intlFormatDateShort(new Date())}.pdf`);
    }
  } catch (error) {
    console.error("Error generating PDF:", error);
  } finally {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
    setLoading(false);
  }
};
